module.exports = __webpack_public_path__ + "img/24.6c6555f1.png";